// extracted by mini-css-extract-plugin
export default {"external":"a9QQXm","articleImg":"b9QQXm"};